import { useState } from 'react';
import Switch from 'react-switch';
import styled from 'styled-components';

import { colors } from 'constants/colors';

import { FutureStockVariationState, useGetFutureStockVariationsByProductQuery } from 'data/__generated__';

import { Loader, LoaderModeType } from 'components/Loader';
import { TotemLabel } from 'components/TotemLabel';
import { FutureStockVariationsTable } from 'pages/Stocks/components/FutureStockVariationsTable';

export const FutureStockVariationsList = ({
    productId,
    warehouseColumnId,
}: {
    productId: string;
    warehouseColumnId: string;
}) => {
    const [hideNotActive, setHideNotActive] = useState(true);
    const { data, loading, error } = useGetFutureStockVariationsByProductQuery({
        variables: {
            productId,
            warehouseColumnId,
        },
    });

    if (loading) {
        return <Loader mode={LoaderModeType.Spin} />;
    }

    if (error || !data) {
        throw new Error('Une erreur est survenue lors de la récupération des variations de stock');
    }

    const { futureStockVariationsByProduct } = data;

    const filteredFutureStockVariations = futureStockVariationsByProduct.filter(({ state }) =>
        hideNotActive ? state === FutureStockVariationState.Ongoing : true,
    );

    return (
        <Container>
            {futureStockVariationsByProduct.length ? (
                <>
                    <SwitchContainer>
                        <SwitchLabel>Afficher tout</SwitchLabel>
                        <Switch
                            onChange={() => setHideNotActive(!hideNotActive)}
                            checked={hideNotActive}
                            onColor={colors.green}
                            offColor={colors.pantinGrey}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            data-test="hide-not-active-switch"
                        />
                        <SwitchLabel>Cacher pas actifs</SwitchLabel>
                    </SwitchContainer>
                    <FutureStockVariationsTable futureStockVariations={filteredFutureStockVariations} />
                </>
            ) : (
                'Pas de variations de stock à venir trouvées'
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const SwitchContainer = styled.div`
    display: flex;
    align-items: center;
`;

const SwitchLabel = styled(TotemLabel)`
    margin: 0 5px;
`;
